import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { FormTextField, FormDatePicker } from '@personal-dashboard/ui';
import dayjs, { Dayjs } from 'dayjs';

interface CreateTaskFormValues {
  title: string;
  dueDate: Dayjs | null;
}

interface CreateTaskDialogProps {
  open: boolean;
  onClose: () => void;
  onCreate: (title: string, dueDate: Dayjs | null) => void;
}

const CreateTaskDialog: React.FC<CreateTaskDialogProps> = ({ open, onClose, onCreate }) => {
  const methods = useForm<CreateTaskFormValues>({
    defaultValues: {
      title: '',
      dueDate: null,
    },
  });

  const { handleSubmit, reset } = methods;

  const handleClose = () => {
    reset({ title: '', dueDate: null });
    onClose();
  };

  const onSubmit = (data: CreateTaskFormValues) => {
    if (!data.title.trim()) return;
    onCreate(data.title, data.dueDate);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 'bold' }}>Create New Task</DialogTitle>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
              <FormTextField
                name="title"
                label="Task Title"
                fullWidth
                placeholder="What needs to be done?"
                autoFocus
              />
              <FormDatePicker
                name="dueDate"
                label="Due Date"
              />
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 2, pt: 0 }}>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit" variant="contained">
              Create Task
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default CreateTaskDialog;
